import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/sgokit.svg';
import PlatformLayout from '../PlatformLayout';
import { Arrow } from '../icons';

export default function About() {
  return (
    <PlatformLayout>
      <section className="sgk-hero">
        <div className="sgk-wrap sgk-hero__grid">
          <div>
            <span className="sgk-eyebrow">Our mission</span>
            <h1>Rebuild the <em>laboratory of democracy.</em></h1>
            <p className="sgk-hero__lede">
              American education works best when families have real choices and communities
              can try real ideas. We support your journey to bring diversity of thought back
              into education — by making the organization that funds it easy to run.
            </p>
            <div className="sgk-hero__ctas">
              <Link to="/signup" className="sgk-btn sgk-btn--gold" data-testid="about-start-button">
                Start an SGO <Arrow />
              </Link>
              <Link to="/platform" className="sgk-btn sgk-btn--ghost" data-testid="about-platform-button">
                See the toolkit
              </Link>
            </div>
          </div>
          <div className="sgk-hero__art">
            <div className="sgk-halo" />
            <img src={logo} alt="" />
          </div>
        </div>
      </section>

      <section className="sgk-section">
        <div className="sgk-wrap">
          <div className="sgk-prose sgk-reveal">
            <p>A scholarship granting organization is a small engine with an outsized job:
              collect gifts, choose scholars fairly, and get money to families who need it —
              all while staying inside a thicket of rules. Too often the machinery eats the
              mission. Founders spend their days on spreadsheets and compliance instead of on
              the students they set out to help.</p>

            <h3>Why now</h3>
            <p>Section 25F of the One Big Beautiful Bill Act changes the math. Beginning in
              2027, individual donors can claim a federal tax credit of up to $1,700 for gifts
              to approved SGOs — in states that opt in, for K–12 scholarships to families
              under three times their local median income. It is the largest tailwind
              school-choice philanthropy has ever had. The organizations ready to receive it
              will define the decade.</p>

            <h3>What we build</h3>
            <p>SGOKit is the toolbox for that moment. Donations, applications, objective
              scoring, disbursement, and the S25F guardrails — in one kit, so a founder can
              stand up a credible, compliant organization in an afternoon and spend the rest
              of their time on scholars. We take no cut of your donations, and we cap what we
              charge so our incentives stay pointed at your success.</p>

            <h3>How we work</h3>
            <p>One platform, one bill, no lock-in. Your donations settle straight into your
              own account; your data and your donor relationships are yours. We measure
              ourselves by a single number: dollars moved from generous people to families
              who need them. When that number goes up, we&apos;ve done our job.</p>
          </div>
        </div>
      </section>

      <section className="sgk-cta">
        <div className="sgk-wrap sgk-cta__grid">
          <div>
            <h2>Help rebuild it with us.</h2>
            <p>Stand up your scholarship granting organization today.</p>
          </div>
          <Link to="/signup" className="sgk-btn sgk-btn--navy" data-testid="about-cta-start-button">
            Start an SGO <Arrow />
          </Link>
        </div>
      </section>
    </PlatformLayout>
  );
}
